import { Formik, FieldArray, Field } from "formik";
import React, { useEffect, useState } from "react";
import { updateVersionHistory } from "../../services/shop.service";
import { toast } from "react-hot-toast";
import Textbox from "../../components/Textbox";

const initialState: any = {
  mobile_version: "",
  electorn_version: "",
  updated_by: "",
  description: "",
  updated_date: "",
};

const CreateUpdateVersion = (props: any) => {
  const [details, setDetails] = useState(initialState);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      if (props.location.details) {
        let version_number = props.location.details.version_number;
        delete props.location.details.version_number;
        if (props.location.details?.version_type == "MOBILE") {
          setDetails({
            ...props.location.details,
            mobile_version: version_number,
          });
        }
        if (props.location.details?.version_type == "DESKTOP") {
          setDetails({
            ...props.location.details,
            electorn_version: version_number,
          });
        }
      }
    } else {
      props.history.push("/login");
    }
  }, []);

  const handleStepSubmit = async (value: any) => {
    setLoader(true);
    localStorage.removeItem("VERSION_TYPE");
    const data = {
      mobile_version: value.mobile_version,
      electorn_version: value.electorn_version,
      updated_by: value.updated_by,
      description: value.description,
      updated_date: value.updated_date,
    };
    updateVersionHistory(data)
      .then((res: any) => {
        setLoader(false);
        toast.success(res.message);
        props.history.push("/version");
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.message);
      });
  };
  return (
    <Formik
      onSubmit={(values) => handleStepSubmit(values)}
      enableReinitialize={true}
      initialValues={details}
      validate={(values) => {}}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        setFieldValue,
        touched,
      }) => (
        <>
          <form onSubmit={handleSubmit}>
            <div className="page-title clearfix">
              <button
                className="back-button mt-1"
                title="Back"
                onClick={() => props.history.push("/version")}
              ></button>
              <button
                disabled={loader}
                className="btn btn-primary primary-out"
                type="submit"
              >
                {props.location.details
                  ? "Update Version"
                  : "Create New Version"}
              </button>
            </div>
            <div className="content-box ">
              <div className="content-body">
                <h1>Version Info</h1>
                <div className="custom-scroll inner-body-wrapper">
                  <div className="scroller">
                    <div>
                      <div className="subtitle clearfix">
                        <h2 className="title2">Version Details</h2>
                      </div>
                      <div className="row">
                        {localStorage.getItem("VERSION_TYPE") == "MOBILE" && (
                          <div className="col-md-12">
                            <Textbox
                              name="mobile_version"
                              placeholder="Enter Mobile Version If Mobile Version"
                              value={values.mobile_version}
                              onChange={handleChange}
                              label="Mobile Version"
                            />
                          </div>
                        )}
                        {localStorage.getItem("VERSION_TYPE") == "DESKTOP" && (
                          <div className="col-md-12">
                            <Textbox
                              name="electorn_version"
                              placeholder="Enter Desktop Version If Desktop Version"
                              value={values.electorn_version}
                              onChange={handleChange}
                              label="Desktop Version"
                            />
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <Textbox
                            name="updated_by"
                            placeholder="Enter your updated_by here"
                            value={values.updated_by}
                            onChange={handleChange}
                            label="Updated By"
                          />
                        </div>
                        <div className="col-md-6">
                          <Textbox
                            name="description"
                            placeholder="Enter your description here"
                            value={values.description}
                            onChange={handleChange}
                            label="description"
                            autoComplete="new-password"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <Textbox
                            name="updated_date"
                            placeholder="Formate-: 2022-01-11(YYYY-MM-DD)"
                            value={values.updated_date}
                            onChange={handleChange}
                            label="Updated Date"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default CreateUpdateVersion;
